var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 80,
    viewBox: "0 0 70 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_103_311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6356 5.92001L34.9475 11.7921L35 11.7641L59.7083 25.8811V54.1149L42.2163 64.1294V75.8776L70 59.999V19.997L35 0L24.6356 5.92001Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 19.997V59.999L35 80L35.0525 79.972V68.2039L35 68.2319L10.2958 54.1149V25.881L17.5283 21.7506L24.7809 25.8731L42.2325 35.7837L34.996 39.9141L34.9798 39.9061L17.5444 30.0115L17.5323 30.0195V49.9645L34.9879 59.9391L35.0363 59.9071L52.4556 49.9565V30.0115L52.4435 30.0035L52.4354 29.9995L34.9596 20.0529L27.707 15.9305L17.3951 10.0584L7.21633 15.8786L0 19.997Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4435 49.9525L35.0363 59.9071L34.996 39.9141L52.4435 30.0035V49.9525Z",
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_103_311"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 80,
    fill: "#000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/footer-logo.ab9a5fc21e3cc9c49e46b3f4dca8d61e.svg";
export { ForwardRef as ReactComponent };